import { render } from "./ProjectCancelAttachmentForm.vue?vue&type=template&id=5c233fd8&scoped=true&ts=true"
import script from "./ProjectCancelAttachmentForm.ts?vue&type=script&lang=ts"
export * from "./ProjectCancelAttachmentForm.ts?vue&type=script&lang=ts"

import "./ProjectCancelAttachmentForm.scss?vue&type=style&index=0&id=5c233fd8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c233fd8"]])

export default __exports__